module.exports = __webpack_public_path__ + "img/no_get_help.e2c99877.svg";